import '@fontsource/roboto';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import '@mantine/notifications/styles.css';
// eslint-disable-next-line import/no-unresolved
import '@gfazioli/mantine-flip/styles.css';
import { ConfigProvider } from 'antd';
import ptBR from 'antd/lib/locale/pt_BR';
import * as dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import theme from './theme';

dayjs.locale('pt-br');
dayjs.extend(customParseFormat);

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  // <React.StrictMode>
  <MantineProvider theme={theme}>
    <ConfigProvider locale={ptBR}>
      <Notifications position="top-right" zIndex={99999} />
      <ModalsProvider modals={{}} labels={{ confirm: 'Sim', cancel: 'Não' }}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ModalsProvider>
    </ConfigProvider>
  </MantineProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
